import {useMutation} from "@tanstack/react-query";
import {message} from "antd";
import {AxiosError} from "axios";
import {UploadKycDocumentsParams, UploadKycDocumentsResult} from "../domain/kyc.types";
import {createKycRepository} from "../data/repositories";
import {AnalyticsEvent} from "../../../utils/analytics";

/**
 * Mutation hook for uploading KYC documents to get S3 URLs.
 * Used by useSubmitKyc orchestration hook before creating the KYC record.
 *
 * Fires analytics events on success/failure.
 */
export const useUploadKycDocuments = () => {
  const repository = createKycRepository();

  return useMutation<
    UploadKycDocumentsResult,
    AxiosError<{message: string}>,
    UploadKycDocumentsParams
  >({
    mutationFn: (params) => repository.uploadDocuments(params),

    onError: (error) => {
      message.error(error.message || "Failed to upload documents");
      AnalyticsEvent("KYC Record", "KYC Record doc upload fail");
    },

    onSuccess: () => {
      AnalyticsEvent("KYC Record", "KYC Record doc upload success");
    },
  });
};
